import {useMemo} from "react";
import {Tabs} from "rsuite";
import Tab from "rsuite/Tab";
import {useLocation, useNavigate} from "react-router-dom";
import AppChangelogs from "./components/AppChangelogs";
import ClockStationFirmwares from "./components/ClockStationFirmwares";
import DeviceFirmwares from "./components/DeviceFirmwares";
import EspFirmwares from "./components/EspFirmwares";
import "./Firmwares.scss";
import {FirmwareTab} from "./Firmwares.model";

const isFirmwareTab = (value: unknown): value is FirmwareTab => {
  return value === "devices" || value === "esp" || value === "app" || value === "clockStation";
};

const Firmwares = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = useMemo<FirmwareTab>(() => {
    const params = new URLSearchParams(location.search);
    const urlTab = params.get("tab");

    return isFirmwareTab(urlTab) ? urlTab : "devices";
  }, [location.search]);

  const handleTabSelect = (eventKey?: string | number) => {
    const nextTab = isFirmwareTab(eventKey) ? eventKey : "devices";
    const params = new URLSearchParams(location.search);

    params.set("tab", nextTab);

    navigate({
      pathname: location.pathname,
      search: `?${params.toString()}`,
    }, {replace: true});
  };

  return (
    <Tabs
      activeKey={activeTab}
      onSelect={handleTabSelect}
      className="firmwares-tabs mt-3"
    >
      <Tab eventKey="devices" title="Устройства">
        {activeTab === "devices" && <DeviceFirmwares />}
      </Tab>

      <Tab eventKey="esp" title="ESP">
        {activeTab === "esp" && <EspFirmwares />}
      </Tab>

      <Tab eventKey="app" title="Платформа">
        {activeTab === "app" && <AppChangelogs />}
      </Tab>

      <Tab eventKey="clockStation" title="Часовая станция">
        {activeTab === "clockStation" && <ClockStationFirmwares />}
      </Tab>
    </Tabs>
  );
};

export default Firmwares;
